import { useState } from 'react';
import { isValidEmail } from '../utils/isValidEmail';
import { useNotifications } from './Notifications';
import { transactionsNewsLetter } from 'integration/generated/transactions';
import { useSettings } from '../Settings';

interface LocalStorageNewsLetter {
	emails: string[];
}

const LOCAL_STORAGE_NEWSLETTER_KEY = 'newsletter_email';

export const getLocalStorageNewsLetter = (): LocalStorageNewsLetter => {
	if (typeof window === 'undefined') return { emails: [] };
	const localStorageCart = window.localStorage.getItem(LOCAL_STORAGE_NEWSLETTER_KEY);
	return localStorageCart ? JSON.parse(localStorageCart) : { emails: [] };
};

export const setLocalStorageNewsLetter = (email: string): void => {
	const localStorageCart = getLocalStorageNewsLetter();
	const newCart = {
		emails: [...localStorageCart.emails, email],
	};
	window.localStorage.setItem(LOCAL_STORAGE_NEWSLETTER_KEY, JSON.stringify(newCart));
};

export const useNewsLetter = () => {
	const [email, setEmail] = useState('');
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);
	const { showSuccessMessage } = useNotifications();
	const { settings } = useSettings();

	const mutateNewsLetter = async () => {
		if (!email) {
			setError('Ingresa tu correo');
			return;
		}

		const emails = getLocalStorageNewsLetter().emails;
		if (emails.includes(email)) {
			setError('El correo ya ha sido registrado');
			return;
		}

		if (!isValidEmail(email)) {
			setError('Ingresa un correo válido');
			return;
		}

		try {
			const storeId = settings?.storeId as string;

			await transactionsNewsLetter(true).subscriptionNewsLetter(storeId, {
				email,
			});

			setLocalStorageNewsLetter(email);

			setSuccess(true);
			showSuccessMessage('El correo se ha registrado exitosamente', 'REGISTRO EXITOSO');
		} catch {
			setError('Ocurrió un error, intenta de nuevo');
		} finally {
			setEmail('');
			setError(null);
		}
	};

	const resetStatus = () => {
		setError(null);
		setSuccess(false);
	};

	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
		resetStatus();
	};

	return {
		emailNewsLetter: email,
		mutateNewsLetter,
		handleEmailChange,
		success,
		error,
		resetStatus,
	};
};
